import { onApiError } from "../error"
import { put } from "./client"

/**
 * @param {string} email 
 * @param {string} password 
 * @param {string} verificationCode 
 */
async function putPassword(email, password, verificationCode) {
    const res = await put("/password", {
        body: JSON.stringify({
            Email: email,
            Password: password,
            VerificationCode: verificationCode,
        })
    })

    if (!res.ok) throw await onApiError(res)
}

export {
    putPassword
}